import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import HomeIcon from "@mui/icons-material/Home";
import CryptoJS from 'crypto-js';
import Cookies from "js-cookie";
import "./Navbar.css";
import {
  APPBAR_STYLES,
  SUB_COLOR,
  DEBI_ROLE,
  COOKIE_KEY,
  DECRYPT_KEY,
  NAVBAR_STYLE_MD,
  NAVBAR_STYLE_XS_BOX,
  NAVBAR_STYLE_XS_MENU,
  COLOR_BLACK,
  NAVBAR_STYLE_MD_BOX,
  DISPLAY_FLEX,
  MR_ML_COLOR,
  ML_CURSOR_POINTER,
  NAVBAR_TYPO
} from "../../../utils/constants/GlobalConstants";
import DOMPurify from "dompurify";
function Navbar(props) {
  const [title,] = React.useState(props.title);
  const [pages, setPages] = React.useState(props.pages);
  const [settings,] = React.useState(props.settings);
  const [username, setUsername] = React.useState('');
  const [role, setRole] = React.useState('');
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const encryptF = Cookies.get(COOKIE_KEY);

  React.useEffect(() => {
    if (encryptF) {
      const bytes = CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
      const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      decryptData && setUsername(`${decryptData.name}`);
      decryptData && setRole(`${decryptData.groups}`);
      const role = decryptData?.group;
      if (role === DEBI_ROLE.DC_CONTACT || role === DEBI_ROLE.SALES_REP) {
        setPages(["Home", "Requests", "Reports"]);
      }
      else if (role === DEBI_ROLE.PARTS_ADMIN) {
        setPages(["Home", "Requests", "Reports", "Maintenance"]);
      }
      else {
        setPages(["Home", "Requests"]);
      }
    }
  }, [encryptF])

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    if (anchorElUser) {
      setAnchorElUser(null);
    } else {
      setAnchorElUser(event.currentTarget);
    }
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleNav = (e, page) => {
    const url = new URL(window.location.href);
    let lastNav;
    if (page === "Maintenance") {
      lastNav = "/debi-tool/maintenance";
    } else if (page === "Reports") {
      lastNav = "/debi-tool/export-excel"
    } else if (page === "Requests") {
      lastNav = "/debi-tool/requests"
    } else if (page === "Home") {
      lastNav = "/debi-tool/home"
    } else if (page === "Access") {
      lastNav = "/debi-tool/role"
    } else if (page === "Logout") {
      Cookies?.remove(COOKIE_KEY);
      lastNav = "/debi-tool/login"
    } else {
      lastNav = "/"
    }

    let finalURL = url.origin + lastNav;
    window.location.href = DOMPurify.sanitize(finalURL)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static" sx={APPBAR_STYLES}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/debi-tool/home"
            sx={NAVBAR_STYLE_MD}
          >
            {title}
          </Typography>

          <Box sx={NAVBAR_STYLE_XS_BOX}>
            <IconButton
              size="large"
              testid="icon"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"

            >
              <MenuIcon />
            </IconButton>
            <Menu
              testid="menu"
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={NAVBAR_STYLE_XS_MENU}
            >
              {pages.map((page, key) => (
                <MenuItem key={key} testid="menu-item" onClick={(e) => handleNav(e, page)}>
                  <Typography textAlign="center" sx={COLOR_BLACK} >
                    {page}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box
            sx={NAVBAR_STYLE_MD_BOX}
          >
            {pages.map((page, key) => (
              <div key={key} style={DISPLAY_FLEX}>
                <Button
                  className="navBtn"
                  sx={MR_ML_COLOR}
                  href={page === "Maintenance" ? "/debi-tool/maintenance"
                    : page === "Reports" ? "/debi-tool/export-excel"
                      : page === "Home" ? "/debi-tool/home"
                        : page === "Requests" ? "/debi-tool/requests"
                          : page === "Access" ? "/debi-tool/role"
                            : "/"}
                >
                  {page === "Home" ? (
                    <HomeIcon sx={{ color: SUB_COLOR }} />
                  ) : (
                    page
                  )}
                </Button>
                <Box
                  sx={{
                    borderRight: `1px solid ${SUB_COLOR}`,
                  }}
                ></Box>
              </div>
            ))}
          </Box>

          <Box
            sx={ML_CURSOR_POINTER}
            onClick={handleOpenUserMenu}
            testid="box"
          >
            <Box sx={DISPLAY_FLEX} className="navBtn">
              <Typography
                sx={NAVBAR_TYPO}
              >
                {username}{` ( ${role} )`}
              </Typography>

              <Tooltip title="Open settings">
                <IconButton sx={{ p: 0 }}>
                  <ArrowDropDownIcon sx={{ color: SUB_COLOR }} />
                </IconButton>
              </Tooltip>
            </Box>

            <Menu
              testid="menu1"
              sx={{ mt: "30px", color: SUB_COLOR }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting, key) => (
                <MenuItem key={key} testid="mobile-nav" onClick={(e) => handleNav(e, setting)}>
                  <Typography
                    textAlign="center"
                    sx={{ color: "black !important" }}
                  >
                    {setting}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;
